const $ = jQuery.noConflict();

'use strict';

const accordion = {
	/**
	* @description Cache dom and strings
	* @type {object}
	*/

	/** @description Initialize */
	init: function() {
		this.accordion();
		if(window.innerWidth > 1199) {
			this.sliderCards();
		}
	},
	/** @description */

	accordion() {
		$('.accordion__button').on('click', function(e) {
			e.preventDefault();
			const $this = $(this);
			if (!$this.hasClass('accordion-active')) {
				$('.accordion__content').slideUp(400);
				$('.accordion__button').removeClass('accordion-active');
				$('.accordion__arrow').removeClass('accordion__rotate');
				$('.accordion__button').parent().removeClass('active-item');
			}
			$this.toggleClass('accordion-active');
			$this.parent().addClass('active-item');
			$this.next().slideToggle();
			$('.accordion__arrow', this).toggleClass('accordion__rotate');
		});
	},
	sliderCards() {

		$('.toggle').hover(
			function() {
				const curr = $(this);
				showOnHover(curr);
			}, function() {
				const curr = $(this);
				hideOnUnhover(curr);
			}
		);

		function showOnHover(curr) {
			const currListItem = curr.find('.slider-cards__list');
			const currParent = curr.parent();
			currListItem.addClass('hover-show');
			currListItem.slideDown(400);
			currParent.addClass('hover-card');
		}

		function hideOnUnhover(curr) {
			const currListItem = curr.find('.slider-cards__list');
			const currParent = curr.parent();
			currListItem.removeClass('hover-show');
			currParent.removeClass('hover-card');
			currListItem.slideUp(100);
		}
	},
};

export default accordion;